module.exports = __webpack_public_path__ + "img/lixinqi.5fea992c.jpg";